/* ==========================================================================
   Femme Bliss — P2 additions (2026-09-16)
   1. Collapse the collection description on phones
   2. Build a table of contents on blog articles
   Both are additive and guarded: missing markup means nothing happens.
   ========================================================================== */
(function () {
  'use strict';

  var MOBILE = window.matchMedia('(max-width: 749px)');

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function slug(text) {
    return text
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 50);
  }

  /* ---------------------------------------------------------------- 1 ----- */
  function initCollectionClamp() {
    if (!MOBILE.matches) return;

    var desc = document.querySelector('.collection-hero__description');
    if (!desc || desc.dataset.fbClamp === 'done') return;

    // Only worth collapsing when it actually costs real screen height.
    if (desc.getBoundingClientRect().height < 120) return;

    desc.classList.add('fb-clamp');
    desc.setAttribute('data-open', 'false');
    desc.dataset.fbClamp = 'done';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'fb-clamp-toggle';
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = 'Read more';

    if (desc.id) {
      btn.setAttribute('aria-controls', desc.id);
    }

    btn.addEventListener('click', function () {
      var open = desc.getAttribute('data-open') === 'true';
      desc.setAttribute('data-open', open ? 'false' : 'true');
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      btn.textContent = open ? 'Read more' : 'Read less';
    });

    desc.parentNode.insertBefore(btn, desc.nextSibling);
  }

  /* ---------------------------------------------------------------- 2 ----- */
  function initArticleToc() {
    var main = document.querySelector('main[data-template]');
    if (!main || (main.dataset.template || '').indexOf('article') !== 0) return;

    var content = document.querySelector('.article-template__content');
    if (!content || content.dataset.fbToc === 'done') return;

    var headings = Array.prototype.slice.call(content.querySelectorAll('h2'));
    if (headings.length < 4) return;

    var list = document.createElement('ol');
    list.className = 'fb-toc__list';

    var used = {};
    headings.forEach(function (h, i) {
      var text = h.textContent.trim();
      if (!text) return;
      var id = h.id;
      if (!id) {
        id = 'fb-h-' + (slug(text) || 'section');
        if (used[id]) id = id + '-' + i;
        used[id] = true;
        h.id = id;
      }
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = text;
      li.appendChild(a);
      list.appendChild(li);
    });

    if (!list.children.length) return;

    var box = document.createElement('details');
    box.className = 'fb-toc';
    if (!MOBILE.matches) box.open = true;

    var summary = document.createElement('summary');
    summary.textContent = 'On this page';
    box.appendChild(summary);
    box.appendChild(list);

    content.insertBefore(box, content.firstChild);
    content.dataset.fbToc = 'done';
  }

  ready(function () {
    try {
      initArticleToc();
    } catch (e) {}
    try {
      initCollectionClamp();
    } catch (e) {}
  });
})();
